export default __webpack_public_path__ + "static/media/depot-stats.c0ec3b13.svg";